export default "__VITE_ASSET__790330d6__"